import { API_BASE_URI } from '@components/env';
import { toastsStore } from '@components/ui/toasts';

import { getClient as getMainClient, getClientUrl } from './functions';
import type { paths } from './swagger';

import { browser } from '$app/environment';

export * as ApiTypes from './types';

export function catchError(e: unknown) {
    console.error(e);
    if (browser && (e as Error).cause == null) {
        toastsStore.error(e && typeof e === 'object' && 'message' in e ? e.message as string : 'Unexpected error');
    }
}

export function catchErrorSilent(e: unknown) {
    console.error(e);
}

export function getClient(
    baseUri: string,
    fetchFun?: typeof fetch,
    headers: Record<string, string> = {},
    catchFunc = catchError
) {
    return getMainClient<paths>(baseUri, fetchFun, headers, catchFunc);
}

export const client = getClient(API_BASE_URI, fetch);
export const silentClient = getClient(API_BASE_URI, fetch, {}, catchErrorSilent);
export const getUrl = getClientUrl<paths>();
